import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { TypeFormation } from 'src/app/shared/models/typeFormation';

@Injectable({
	providedIn: 'root'
})
export class TypeFormationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllTypeFormation(): Observable<TypeFormation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeFormationUrl}/all`,
			'getAllTypeFormation'
		);
	}

	importTypeFormation(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'typeFormation.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeFormationUrl}/import`,
			`importTypeFormation`,
			formData
		);
	}

	getTypeFormationById(id: number): Observable<TypeFormation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeFormationUrl}/get/${id}`,
			'getTypeFormationById'
		);
	}

	updateTypeFormation(typeFormation: TypeFormation): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.typeFormationUrl}/update/${typeFormation.id}`,
			'updateTypeFormation',
			typeFormation
		);
	}

	addTypeFormation(typeFormation: TypeFormation): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeFormationUrl}/add`,
			'addTypeFormation',
			typeFormation
		);
	}

	deleteTypeFormation(typeFormationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.typeFormationUrl}/delete/${typeFormationId}`,
			`deleteTypeFormation`
		);
	}
}
